import { useNavigate, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import ContentHeader from "components/ContentHeader/ContentHeader";
import useAdmin from "app/routes/middleware/Admin/useAdmin";
import GenericEntityForm from "components/common/GenericEntityForm";
import { useCallback } from "react";
import entityService from "app/services/entity-service";
import useMetaTitle from "app/hooks/useMetaTitle";

const AdminEntityCreateUpdateForm = ({ entityConfig }) => {
  const { id } = useParams();
  const isAdmin = useAdmin();
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const handleAction = useCallback(
    (action) => {
      switch (action.id) {
        case "back":
          handleBack();
          break;
        default:
          console.log("Unknown action:", action);
      }
    },
    [handleBack]
  );

  useMetaTitle({
    title: id ? `Update ${id}` : `Add New ${entityConfig.sectionTitle}`,
  });

  return (
    <Box sx={{ height: "100%" }}>
      <JumboCardQuick
        title={
          <ContentHeader
            isAdmin={isAdmin}
            onAction={handleAction}
            allowedActions={isAdmin ? ["back"] : ["back"]}
            showLeftTabs={true}
          />
        }
        headerSx={{
          borderBottom: 1,
          borderColor: "divider",
          "& .MuiCardHeader-action": { my: -0.75 },
        }}
        wrapperSx={{ p: 0 }}
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          "& .MuiCardContent-root:last-child": { paddingBottom: 0 },
          "& .MuiCardContent-root": {
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <GenericEntityForm
          entityConfig={entityConfig}
          id={id}
          mode={id ? "update" : "add"}
          fetchService={entityService.fetchDetailsById}
          createService={entityService.create}
          updateService={entityService.update}
          title={
            id
              ? `Update ${entityConfig.sectionTitle}`
              : `Add ${entityConfig.sectionTitle}`
          }
        />
      </JumboCardQuick>
    </Box>
  );
};

export default AdminEntityCreateUpdateForm;
